import { Modelo } from '@ext/index';
import * as Types from './Reputacion.types';
import * as Pedidos from '@lib/Ventas/Pedidos';
import moment, { Moment } from 'moment';
import { Cuenta } from '@/__env/lib/MercadoLibre/Cuentas/Cuentas';

export class IReputacion extends Modelo
{

    public constructor( Json: any = null )
    {
        super( Json );
        if ( Json )
            this.set();
    }

    public Fecha: Moment;
    public Cuenta: string;
    public Color: string;
    public Ventas = {
        Concretadas: 0,
        Canceladas:0
    };
    
    public Porcentajes = {
        Reclamos: 0,
        Demoras: 0,
        Canceladas: 0,
    }


    public set(): boolean
    {

        this.Fecha = moment( this.Json.fecha );
        this.Cuenta = this.Json.cuenta;
        this.Color = this.Json.color;
        this.Ventas.Concretadas = this.Json.ventas;
        this.Ventas.Canceladas = this.Json.ventas_canceladas;

        this.Porcentajes.Reclamos = this.Json.reclamos ? this.Json.reclamos * 100 : 0;
        this.Porcentajes.Canceladas = this.Json.canceladas ? this.Json.canceladas * 100 : 0;
        this.Porcentajes.Demoras = this.Json.demoras ? this.Json.demoras * 100 : 0;

        this.Existe = true;
        return this.Existe;
    }

    public get Vista(): Vista
    {
        return new Vista( this );
    }
}

class Vista
{
    constructor( Model: IReputacion )
    {
        this.Model = Model;
    }

    public Model: IReputacion;
}